import { application } from "./application"

// Import and register all your controllers from the importmap under controllers/*

// Register our custom controllers
import SortableController from "./sortable_controller"
import DraggableController from "./draggable_controller"
import TabsController from "./tabs_controller"
import RadioToggleController from "./radio_toggle_controller"
import SelectDropdownController from "./select_dropdown_controller"
import DownloadAllMediaController from "./download_all_media_controller"

application.register("sortable", SortableController)
application.register("draggable", DraggableController)
application.register("tabs", TabsController)
application.register("radio-toggle", RadioToggleController)
application.register("select-dropdown", SelectDropdownController)
application.register("download-all-media", DownloadAllMediaController)
